import "./Pricing.css";

import logo1 from "../Assets/Icons/amazon.png";
import logo2 from "../Assets/Icons/Bill.png";
import logo3 from "../Assets/Icons/Drake.png";
import logo4 from "../Assets/Icons/Ebay.png";
import logo6 from "../Assets/Icons/Payoneer.png";
import logo7 from "../Assets/Icons/Paypal.png";
import logo8 from "../Assets/Icons/QuickBooks.png";
import logo9 from "../Assets/Icons/Shopigy.png";
import logo10 from "../Assets/Icons/Stripe.png";
import logo11 from "../Assets/Icons/Xero.png";
import logo12 from "../Assets/Icons/ZohoBooks.png";
import logo13 from "../Assets/Icons/ZohoPayroll.png";

// Define the logos array with imported images
const logos = [
  { src: logo1, alt: "Amazon" },
  { src: logo2, alt: "Bill" },
  { src: logo3, alt: "Drake" },
  { src: logo4, alt: "Ebay" },
  { src: logo6, alt: "Payoneer" },
  { src: logo7, alt: "Paypal" },
  { src: logo8, alt: "QuickBooks" },
  { src: logo9, alt: "Shopify" },
  { src: logo10, alt: "Stripe" },
  { src: logo11, alt: "Xero" },
  { src: logo12, alt: "ZohoBooks" },
  { src: logo13, alt: "ZohoPayroll" },
];

const LogoSlider = () => {
  return (
    <div className="logo-slider">
      <div className="slider-track">
        {/* Duplicate the logos array for infinite loop effect */}
        {logos.concat(logos).map((logo, index) => (
          <img key={index} src={logo.src} alt={logo.alt} />
        ))}
      </div>
    </div>
  );
};

export default LogoSlider;